import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {StrainReportModel} from "@app/strain/common/models/strain-report.model";
import {StrainMeasurement} from "@app/strain/common/models/strain-registry-measurement.model";

@Component({
    selector: 'app-strain-scheduled-card',
    templateUrl: './strain-process-scheduled-card.component.html',
    styleUrls: ['./strain-process-scheduled-card.component.scss']
})
export class StrainProcessScheduledCardComponent implements OnInit {

    @Input() measurement: StrainMeasurement;

    @Output() reportClick = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit() {
    }

    onReportClick(report: StrainReportModel) {
        this.reportClick.emit({
            measurementId: this.measurement.id,
            report: report
        });
    }
}
